import React from "react";
import { FluentTabList } from "../../../../components/FluentUI/Fluent-TabList";
import PropTypes from "prop-types";
import { FluentButton } from "../../../../components/FluentUI/Fluent-Button";
import FluentUiIcon from "../../../../assets/fluent-ui-icon";

export default function TaskFormSidePanel({
  subFormLabels,
  currentSubForm,
  label,
  TabChange,
  IsView,
}) {
  return (
    <div className="side-panel">
      {!IsView && (
        <div className="d-flex justify-content-between header">
          <div className="header-ellipsis">{label}</div>
          <div className="invisible">
            <FluentButton
              icon={
                <FluentUiIcon
                  name={"FlashAutoRegular"}
                  color={"#0F6CBD"}
                  size={20}
                />
              }
            />
          </div>
        </div>
      )}
      <FluentTabList
        tabList={subFormLabels}
        tabClick={TabChange}
        currentTab={currentSubForm?.Id}
      />
    </div>
  );
}

TaskFormSidePanel.propTypes = {
  subFormLabels: PropTypes.arrayOf(
    PropTypes.shape({
      Id: PropTypes.string.isRequired,
      Label: PropTypes.string.isRequired,
    })
  ).isRequired,
  currentSubForm: PropTypes.shape({
    Id: PropTypes.string.isRequired,
  }),
  label: PropTypes.string.isRequired,
  TabChange: PropTypes.func.isRequired,
  IsView: PropTypes.bool.isRequired,
};
